import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output, TemplateRef } from '@angular/core';

export interface TellentMobileSheetOption {
  id: string;
  label: string;
  destructive?: boolean;
  disabled?: boolean;
}

export interface TellentMobileSheetOptionIconContext {
  $implicit: TellentMobileSheetOption;
}

@Component({
  selector: 'tlm-options-sheet',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet],
  templateUrl: './options-sheet.component.html',
  styleUrl: './options-sheet.component.less',
})
export class TellentMobileOptionsSheetComponent {
  public readonly title = input('');
  public readonly optionGroups = input.required<TellentMobileSheetOption[][]>();
  // Domain-specific headers (avatars, statuses) and per-option icons stay in the
  // host app; templates keep this component free of app icon/avatar components.
  public readonly headerTemplate = input<TemplateRef<unknown>>();
  public readonly iconTemplate = input<TemplateRef<TellentMobileSheetOptionIconContext>>();
  // Callback alternative to the `selected` output for hosts that present this
  // component through an overlay controller, where output bindings are unavailable.
  public readonly selectHandler = input<(option: TellentMobileSheetOption) => void>();

  public readonly selected = output<TellentMobileSheetOption>();

  protected select(option: TellentMobileSheetOption): void {
    this.selected.emit(option);
    this.selectHandler()?.(option);
  }
}
